const mutations = {
  setOutletData: (state, payload) => {
    state.outletData = payload;
  },
  setFilterTransaksi: (state, payload) => {
    state.filterTransaksi = payload.filter;
    state.filterCount = payload.filterCount
  },
  setDetailPenerimaan: (state, payload) => {
    state.detailPenerimaan = payload;
  },
  upDateFilterCount: (state, payload) => {
    state.filterCount = payload;
  },
  setDefaultFilter: (state, payload) => {
    state.defaultFilter = {
      filter:  JSON.parse(JSON.stringify(payload.filter)),
      filterItem: JSON.parse(JSON.stringify(payload.filterItem))
    }
  },
  resetFilter: (state) => {
    state.filterTransaksi = JSON.parse(JSON.stringify(state.defaultFilter.filter));
  },
};

export default mutations;
